package one.healthium.domain.paywall.models


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class PaywallSet(
    @SerialName("paywall") val config: PaywallSetConfig,
    @SerialName("remarketing_offers") val remarketingOffers: List<RemarketingOffer>,
)


@Serializable
data class PaywallSetConfig(
    @SerialName("id") val paywallId: String,
    @SerialName("remarketing_id") val remarketingId: String? = null,
    @SerialName("delay") val delay: Boolean,
    @SerialName("delay_timeout") val delayTimeout: Float,
)


@Serializable
data class RemarketingOffer(
    @SerialName("paywall_id") val paywallId: String? = null,
    @SerialName("notification") val notification: RemarketingNotification,
)


@Serializable
data class RemarketingNotification(
    @SerialName("time_interval") val timeInterval: Int,
    @SerialName("title") val title: String,
    @SerialName("body") val body: String,
)